import { render, staticRenderFns } from "./Manuscrits.vue?vue&type=template&id=656790ff&scoped=true"
import script from "./Manuscrits.vue?vue&type=script&lang=js"
export * from "./Manuscrits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656790ff",
  null
  
)

export default component.exports